export function sendDataToSentry(stage: string, error: any) {
  try {
    const { Sentry } = window as any;
    if (Sentry) {
      Sentry.captureException(error, {
        tags: {
          stage
        }
      });
    } else {
      console.log(stage, error);
    }
  } catch (e) {
    console.log('Failed to push data to sentry. ERROR = ', e);
  }
}

export function sentryCaptureMessage(stage: string, message: any) {
  try {
    const { Sentry } = window as any;
    if (Sentry) {
      Sentry.captureMessage(message, {
        tags: {
          stage
        }
      });
    } else {
      console.log(stage, message);
    }
  } catch (e) {
    console.log('Failed to push data to sentry. ERROR = ', e);
  }
}

export default sendDataToSentry;
